// PosEase support details shown on the public booking pages
export const CONTACT_US_URL = "https://www.posease.com/contact-us/";
export const CONTACT_MOBILE = "+919501795038";
export const CONTACT_MOBILE_LABEL = "+91 95017 95038";
export const CONTACT_EMAIL = "sales@posease.com";
